<template>
    <div class="footer">
        <div class="white">
            <img src="@/assets/img/logo.png" />
        </div>
        <div class="container floater row d-none d-md-flex">
            <div class="contact col">
                <div class="icon">
                    <i class="fa fa-phone"></i>
                </div>
                <div class="flex-row">
                    <span><a href="mailto:info@cegjelzo.hu">info@cegjelzo.hu</a></span>
                    <span>+36 30 624 4530</span>
                </div>
            </div>
            <div class="contact col">
                <div class="icon">
                    <i class="fa fa-globe"></i>
                </div>
                <div class="flex-row">
                    <span><a href="/Cegjelzo_adatkezelesi_tajekoztato.pdf" target="_blank">Adatkezelési Tájékoztató</a></span>
                </div>
            </div>
            <div class="contact col">
                <div class="icon">
                    <i class="fa fa-map-marker"></i>
                </div>
                <div class="flex-row">
                    <span>1124 Budapest,</span>
                    <span>Kempelen Farkas utca 1.</span>
                </div>
            </div>
        </div>
        <div class="container floater row d-block d-md-none">
            <div class="contact col">
                <div class="icon">
                    <i class="fa fa-phone"></i>
                </div>
                <div class="flex-row">
                    <span><a href="mailto:info@cegjelzo.hu">info@cegjelzo.hu</a></span>
                    <span><a href="tel:+36306244530">+36 30 624 4530</a></span>
                </div>
            </div>
            <div class="contact col">
                <div class="icon">
                    <i class="fa fa-globe"></i>
                </div>
                <div class="flex-row">
                    <span><a href="/ASZF.pdf" target="_blank">Általános Szerződési Feltételek</a></span>
                    <span><a href="/Adatkezelesi_tajekoztato.pdf" target="_blank">Adatkezelési Tájékoztató</a></span>
                </div>
            </div>
            <div class="contact col">
                <div class="icon">
                    <i class="fa fa-map-marker"></i>
                </div>
                <div class="flex-row">
                    <span>1124 Budapest,</span>
                    <span>Kempelen Farkas utca 1.</span>
                </div>
            </div>
        </div>
        <div class="green">
            <span>Copyright © 2017-2019 Cégjelző all rights reserved.</span>
            <div class="d-block d-sm-none">
                <p>-</p>
                <p>
                    This site is protected by reCAPTCHA and the Google
                    <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                    <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
    display: block;
    position: relative;
}

.white {
    background: white;
    text-align: center;
    padding-bottom: 125px;
}

.white img {    
    max-height: 50px;
}

.floater {
    position: absolute;
    background: white;
    -webkit-box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.2);
    box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.2);
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top: 88px;
    border-radius: 1px;
    padding: 50px;
}

.icon {
    width: 54px;
    height: 54px;
    border: 1px solid var(--color-grey-1);
    border-radius: 10px;
    display: flex;
    margin-right: 15px;
}

i {
    font-size: 1.4em;
    margin: auto;
}

i.fa-phone {
    transform: scaleX(-1);
}

.contact {
    display: flex;
}

.contact p {
    margin-bottom: 0;
}

.flex-row {
    flex-direction: column !important;
    width: auto;
    margin-top: auto;
    margin-bottom: auto;
}

.flex-row span {
    font-size: 14px;
}

.green {
    background: var(--color-green-1);
    text-align: center;
    padding-top: 125px;
    padding-bottom: 40px;
    color: white;
    font-weight: 100;
}

a {
    color: inherit;
}

@media (max-width: 480px) {
    .white {
        background: white;
        text-align: center;
        padding-bottom: 0;
    }

    .floater {
        position: relative;
        background: white;
        -webkit-box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.2);
        -moz-box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.2);
        box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.2);
        border-radius: 1px;
        padding: 12px;
    }

    .floater .contact {
        margin-bottom: 12px;
    }
}
</style>
